// extracted by mini-css-extract-plugin
export var completionBody = "_ca-2";
export var completionCard = "_ca-0";
export var completionFooter = "_ca-3";
export var completionTitle = "_ca-1";